import Stats from '../stats';
import FieldVisibility from '../settings/fieldVisibility';
import Dashboard from '../dashboard';
import ActivityReport from '../activityReport';
import UserList from '../userList';
import UserDetails from '../userDetails';
import AffiliateList from '../affiliateList';
import AffiliateDetails from '../affiliateDetails';
import PrivacyAuditDetails from '../privacyAuditDetails';
import PrivacyAuditList from '../privacyAuditList';
import QuestionaryDetails from '../questionaryDetails';
import QuestionaryList from '../questionaryList';
import TomDetails from '../tomDetails';
import TomList from '../tomList';
import CompanyList from '../companyList';
import CompanyDetails from '../companyDetails';
import ClientList from '../clientList';
import ClientDetails from '../clientDetails';
import ResellerUser from '../resellerUser';
import ResellerAgentList from '../resellerAgentList';
import ResellerAgent from '../resellerAgent';
import OrganizationalUnitList from '../organizationalUnitList';
import OrganizationalUnitDetails from '../organizationalUnitDetails';
import EmployeeList from '../employeeList';
import EmployeeDetails from '../employeeDetails';
import Training from '../training';
import TrainingList from '../trainingList';
import TrainingEditor from '../trainingEditor';
import TrainingEditorList from '../trainingEditorList';
import SharedDocumentList from '../sharedDocumentList';
import TaskList from '../taskList';
import AvContractList from '../avContractList';
import AvContractDetails from '../avContractDetails';
import DepartmentList from '../departmentList';
import DepartmentDetails from '../departmentDetails';
import ProcedureDirectoryList from '../procedureDirectoryList';
import ProcedureDirectoryDetails from '../procedureDirectoryDetails';
import InfoPortal from '../infoPortal';
import BlogEntryDetails from '../blogEntryDetails';
import BlogEntryList from '../blogEntryList';

export const componentMap = {
  stats: {
    component: 'Stats',
    title: 'Stats',
  },
  'field-visibility': {
    component: 'FieldVisibility',
    title: 'Field Visibility',
  },
  dashboard: {
    component: 'Dashboard',
    title: 'Dashboard',
  },
  activityReport: {
    component: 'ActivityReport',
    title: 'Jahrestätigkeitsbericht',
  },
  users: {
    component: 'UserList',
    title: 'Benutzer',
  },
  user: {
    component: 'UserDetails',
    title: 'Loading...',
  },
  affiliate: {
    component: 'AffiliateDetails',
    title: 'Loading...',
  },
  privacyAudits: {
    component: 'PrivacyAuditList',
    title: 'Audits',
  },
  privacyAudit: {
    component: 'PrivacyAuditDetails',
    title: 'Loading...',
  },
  questionaries: {
    component: 'QuestionaryList',
    title: 'Fragenkataloge',
  },
  questionary: {
    component: 'QuestionaryDetails',
    title: 'Loading...',
  },
  toms: {
    component: 'TomList',
    title: 'Toms',
  },
  tom: {
    component: 'TomDetails',
    title: 'Loading...',
  },
  procedureDirectories: {
    component: 'ProcedureDirectoryList',
    title: 'Verfahren',
  },
  procedureDirectory: {
    component: 'ProcedureDirectoryDetails',
    title: 'Loading...',
  },
  companies: {
    component: 'CompanyList',
    title: 'Stammdaten',
  },
  company: {
    component: 'CompanyDetails',
    title: 'Loading...',
  },
  clients: {
    component: 'ClientList',
    title: 'Mandanten',
  },
  client: {
    component: 'ClientDetails',
    title: 'Loading...',
  },
  resellerUser: {
    component: 'ResellerUser',
    title: 'Benutzerdaten',
  },
  resellerAgents: {
    component: 'ResellerAgentList',
    title: 'Vertretung',
  },
  resellerAgent: {
    component: 'ResellerAgent',
    title: 'Loading...',
  },
  organizationalUnits: {
    component: 'OrganizationalUnitList',
    title: 'Organisationseinheiten',
  },
  organizationalUnit: {
    component: 'OrganizationalUnitDetails',
    title: 'Loading...',
  },
  employees: {
    component: 'EmployeeList',
    title: 'Mitarbeiter',
  },
  employee: {
    component: 'EmployeeDetails',
    title: 'Loading...',
  },
  trainings: {
    component: 'TrainingList',
    title: 'Schulungen',
  },
  trainingEditor: {
    component: 'TrainingEditor',
    title: 'Loading...',
  },
  trainingEditorList: {
    component: 'TrainingEditorList',
    title: 'Schulungen',
  },
  sharedDocuments: {
    component: 'SharedDocumentList',
    title: 'Vorlagen',
  },
  training: {
    component: 'Training',
    title: 'Schulung',
  },
  tasks: {
    component: 'TaskList',
    title: 'Aufgaben',
  },
  affiliates: {
    component: 'AffiliateList',
    title: 'Vertragspartner',
  },
  avContracts: {
    component: 'AvContractList',
    title: 'AV-Verträge',
  },
  avContract: {
    component: 'AvContractDetails',
    title: 'Loading...',
  },
  departments: {
    component: 'DepartmentList',
    title: 'Abteilungen',
  },
  department: {
    component: 'DepartmentDetails',
    title: 'Loading...',
  },
  infoPortal: {
    component: 'InfoPortal',
    title: 'Infoportal',
  },
  blogEntryDetails: {
    component: 'BlogEntryDetails',
    title: 'Loading...',
  },
  blogEntries: {
    component: 'BlogEntryList',
    title: 'Blog-Einträge',
  },
};

export const components = {
  Stats,
  FieldVisibility,
  Dashboard,
  ActivityReport,
  UserList,
  UserDetails,
  TaskList,
  AffiliateList,
  AffiliateDetails,
  PrivacyAuditDetails,
  PrivacyAuditList,
  QuestionaryDetails,
  QuestionaryList,
  TomList,
  TomDetails,
  ProcedureDirectoryList,
  ProcedureDirectoryDetails,
  CompanyList,
  CompanyDetails,
  ClientList,
  ClientDetails,
  ResellerUser,
  ResellerAgentList,
  ResellerAgent,
  OrganizationalUnitList,
  OrganizationalUnitDetails,
  EmployeeList,
  EmployeeDetails,
  Training,
  TrainingList,
  TrainingEditorList,
  TrainingEditor,
  SharedDocumentList,
  AvContractList,
  AvContractDetails,
  DepartmentList,
  DepartmentDetails,
  InfoPortal,
  BlogEntryDetails,
  BlogEntryList,
};
